import { useGetWorkTemplateCreateData } from 'ogp/hooks/queryHooks/jobs/use-get-work-template-create-data';
import { RenderUnsettledUI } from 'shared/components';
import { useParams } from 'react-router-dom';
import { useGetCompanyEmploymentTypes } from 'ogp/hooks/queryHooks/companies/use-get-company-employment-types';
import { useGetWorkTemplate } from 'api';
import { useSiteDetection } from 'shared/hooks';
import { invariant } from 'shared/utils/utils';
import { WorkTemplateCreatePage } from './work-template-create-page';
import { jobAlerts } from '../../../../../../../shared/components/alerts';
import { encodeJobToJobForm } from '../utils';

export const WorkTemplateDuplicateDataProvider = () => {
  const { id } = useParams<'id'>();
  invariant(id, 'Job ID must be defined');

  const { site } = useSiteDetection();
  const jobQuery = useGetWorkTemplate(site, id, !!id);
  const workTemplateCreateDataQuery = useGetWorkTemplateCreateData();
  const employmentType = useGetCompanyEmploymentTypes();

  if (workTemplateCreateDataQuery.status !== 'success') {
    return <RenderUnsettledUI data={workTemplateCreateDataQuery} />;
  }

  if (jobQuery.status !== 'success') {
    return <RenderUnsettledUI data={jobQuery} />;
  }

  if (employmentType.status !== 'success') {
    return <RenderUnsettledUI data={employmentType} />;
  }

  const defaultValues = encodeJobToJobForm(jobQuery.data);

  return (
    <WorkTemplateCreatePage
      jobCreateData={workTemplateCreateDataQuery.data}
      pageTitle={`Functie ${defaultValues.workName} dupliceren`}
      defaultValues={defaultValues}
      successMessage={jobAlerts.success.created}
      employmentType={employmentType.data}
    />
  );
};
